import Labeled from 'admin/components/atoms/Labeled';
import Radio from 'admin/components/atoms/Radio';
import { randomAlphanumeric } from 'admin/utils';
import React from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

type LabeledProps = StyledComponentPropsWithRef<typeof Labeled>;

type Props = {
  labelText?: LabeledProps['labelText'];
  className?: LabeledProps['className'];
  labelPosition?: LabeledProps['labelPosition'];
  id?: string;
} & StyledComponentPropsWithRef<typeof Radio>;

const LabeledRadio = ({
  labelText = '',
  className = '',
  labelPosition = 'left',
  id,
  ...rest
}: Props) => {
  const iid = id || randomAlphanumeric(16);
  return (
    <Labeled
      labelText={labelText}
      className={className}
      labelPosition={labelPosition}
      htmlFor={iid}
    >
      <Radio id={iid} {...rest} />
    </Labeled>
  );
};

export default styled(LabeledRadio)``;
